var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0533 17.0668C21.4933 17.6135 21.1733 18.4002 21.2533 19.2402C21.3733 20.6802 22.6933 21.7335 24.1333 21.7335H26.6666V23.3202C26.6666 26.0802 24.4133 28.3335 21.6533 28.3335H6.34665C3.58665 28.3335 1.33331 26.0802 1.33331 23.3202V14.3468C1.33331 11.5868 3.58665 9.3335 6.34665 9.3335H21.6533C24.4133 9.3335 26.6666 11.5868 26.6666 14.3468V16.2668H23.9733C23.2266 16.2668 22.5466 16.5601 22.0533 17.0668Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 15.5467V9.45347C1.33331 7.86681 2.30665 6.45341 3.78665 5.89341L14.3733 1.89341C16.0266 1.26675 17.8 2.49345 17.8 4.26679V9.33344",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0784 17.627V20.3738C28.0784 21.1071 27.4917 21.7071 26.7451 21.7337H24.1317C22.6917 21.7337 21.3717 20.6804 21.2517 19.2404C21.1717 18.4004 21.4917 17.6137 22.0517 17.0671C22.5451 16.5604 23.2251 16.2671 23.9717 16.2671H26.7451C27.4917 16.2938 28.0784 16.8937 28.0784 17.627Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 15H16.6666",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon_wallet.e96e7ebc96553463182e159435206c9d.svg";
export { ForwardRef as ReactComponent };